
import qs from 'qs';
import fetch from '@/utils/fetch';
import {getPublicParams} from '@/utils/utils'

// 城市列表（新）
export function getAllCityByGroup(params) {
	let obj = getPublicParams(params);
	return fetch(`/c-city-consumer/city/v2/get-all-city-by-group?${qs.stringify(params)}`, {
		headers: obj,
    needCode:true
	});
}

// 迁入标准
export function getImmigration(params) {
 
	return fetch(`/c-carsource-consumer/accessstandard/immigration?${qs.stringify(params)}`);
}

// 热门品牌
export function getMbRankList(params) {
	return fetch(`/c-carbrand-consumer/carbrand/getMbRankList?${qs.stringify(params)}`, {
    needCode:true
  });
}

// 全部品牌
export function getbrandmaster(params) {
	return fetch(`/c-carbrand-consumer/carbrand/getbrandmaster?${qs.stringify(params)}`, {
    needCode:true
  });
}
// 车系选择
export function getbrandserial(params) {
	return fetch(`/c-carbrand-consumer/carbrand/v2/getbrandserial?${qs.stringify(params)}`, {
    needCode:true
  });
}

// 快速筛选-特色
export const getRecInfoForCarList = (body) =>
  fetch("/c-car-consumer/carsource/getRecInfoForCarList", {
    method: "post",
    body:{
      terminal : 40,
      listRowConut : 20,
    },
    needCode:true
  });


// 门店列表
export const getStoreList = (params) =>  fetch(`/c-carsource-consumer/delivery/listByDistance?${qs.stringify(params)}`);
